import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { transportistaRedirect } from './transportista-allowlist';

export const authGuard = (_route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    // feat-rol-transportista: fuera de su lista de permitidos vuelve a la Torre.
    return (state && transportistaRedirect(authService, router, state.url)) ?? true;
  } else {
    router.navigate(['/']);
    return false;
  }
};
